import { defineMessages } from 'react-intl-next';

export default defineMessages({
    knowledgeBaseResultTitle: {
        defaultMessage: 'Articles',
        description: 'Section header for knowledge base search results',
        id: 'cv.search.results.knowledgebase',
    },
    portalResultTitle: {
        defaultMessage: 'Portals',
        description: 'Section header for service project / portal search results',
        id: 'cv.search.results.portals',
    },
    requestTypesResultTitle: {
        defaultMessage: 'Send a request about',
        description: 'Section header for request types search results',
        id: 'cv.search.results.requesttypes',
    },
    expandArticleResultsButtonText: {
        defaultMessage: 'Show more',
        description: 'Text for expand article results button',
        id: 'cv.search.results.expandarticleresults',
    },
    allArticleResultsButtonText: {
        defaultMessage: 'Show more articles ({numArticles})',
        description: 'Text for navigating to all article results page button',
        id: 'cv.search.results.allarticleresults',
    },
});
